/**
 * All Hunter abilities except talents go in here. You can also put a talent in here if you want to override something imported in the `./talents` folder, but that should be extremely rare.
 * You need to do this manually, usually an easy way to do this is by opening a WCL report and clicking the icons of spells to open the relevant Wowhead pages, here you can get the icon name by clicking the icon, copy the name of the spell and the ID is in the URL.
 * You can access these entries like other entries in the spells files by importing `common/SPELLS` and using the assigned property on the SPELLS object. Please try to avoid abbreviating properties.
 */
import Spell from 'common/SPELLS/Spell';

const spells = {
  MULTI_SHOT: {
    id: 2643,
    name: 'Multi-Shot',
    icon: 'ability_upgrademoonglaive',
    focusCost: 40,
  },
  //region Beast Mastery
  BEAST_CLEAVE_DAMAGE: {
    id: 118459,
    name: 'Beast Cleave',
    icon: 'ability_hunter_sickem',
  },
  STOMP_DAMAGE: {
    id: 201754,
    name: 'Stomp',
    icon: 'ability_warstomp',
  },
  DIRE_BEAST_SUMMON: {
    id: 1283818,
    name: 'Dire Beast',
    icon: 'ability_hunter_sickem',
  },
  // Separate from DIRE_BEAST_SUMMON - this is the `cast` event marker attributed to the player
  // when a Dire Beast is summoned (as opposed to the `summon` event for the pet itself), which
  // shows up on the Timeline. Left unlabeled it falls back to raw report data and shows a stale ID.
  DIRE_BEAST_CAST: {
    id: 255283,
    name: 'Dire Beast',
    icon: 'ability_hunter_sickem',
  },
  MID1_4P_BONUS_BEAST_MASTERY: {
    id: 1264826,
    name: 'Beast Mastery 4-Set',
    icon: 'ability_hunter_sickem',
  },
  DIRE_BEAST_GLYPHED: {
    id: 219199,
    name: 'Dire Beast',
    icon: 'ability_hunter_sickem',
  },
  DARK_HOUND_SUMMON: {
    id: 442419,
    name: 'Dark Hound',
    icon: 'inv_darkhoundmount_draka_blue',
  },
  DIRE_PACK_BUFF: {
    id: 378747,
    name: 'Dire Pack',
    icon: 'ability_hunter_sickem',
  },
  BEAST_CLEAVE_BUFF: {
    id: 268877,
    name: 'Beast Cleave',
    icon: 'ability_hunter_sickem',
  },
  BEAST_CLEAVE_PET_BUFF: {
    id: 118455,
    name: 'Beast Cleave',
    icon: 'ability_hunter_sickem',
  },
  BESTIAL_WRATH_BUFF_MAIN_PET: {
    id: 186254,
    name: 'Bestial Wrath Buff',
    icon: 'ability_druid_ferociousbite',
  },
  BARBED_SHOT_BUFF: {
    id: 246152,
    name: 'Barbed Shot',
    icon: 'ability_hunter_barbedshot',
  },
  BARBED_SHOT_PET_BUFF: {
    id: 272790,
    name: 'Frenzy',
    icon: 'ability_hunter_barbedshot',
  },
  THRILL_OF_THE_HUNT_BUFF: {
    id: 257946,
    name: 'Thrill of the Hunt',
    icon: 'ability_hunter_thrillofthehunt',
  },
  NATURES_ALLY_BUFF: {
    id: 1276720,
    name: "Nature's Ally",
    icon: 'ability_hunter_goforthethroat',
  },
  BLOODSHED_DEBUFF: {
    id: 321538,
    name: 'Bloodshed',
    icon: 'ability_hunter_killcommand',
  },
  CALL_OF_THE_WILD_TEMPORARY_PET_BUFF: {
    id: 361582,
    name: 'Call of the Wild',
    icon: 'ability_hunter_pet_assist',
  },
  PACK_TACTICS_ENERGIZE: {
    id: 1282660,
    name: 'Pack Tactics',
    icon: 'ability_hunter_barbedshot',
  },
  SERPENTINE_STRIKES_ENERGIZE: {
    id: 1282710,
    name: 'Serpentine Strikes',
    icon: 'ability_hunter_cobrashot',
  },
  //endregion

  //region Marksmanship
  BULLETSTORM_BUFF: {
    id: 389020,
    name: 'Bulletstorm',
    icon: 'ability_hunter_markedshot',
  },
  BULLSEYE_BUFF: {
    id: 204090,
    name: 'Bullseye',
    icon: 'ability_hunter_focusedaim',
  },
  DEATHBLOW_BUFF: {
    id: 378770,
    name: 'Deathblow',
    icon: 'ability_hunter_runningshot',
  },
  DOUBLE_TAP_BUFF: {
    id: 260402,
    name: 'Double Tap',
    icon: 'ability_hunter_crossfire',
  },
  LOCK_AND_LOAD_BUFF: {
    id: 194594,
    name: 'Lock and Load',
    icon: 'ability_hunter_lockandload',
  },
  MASTER_MARKSMAN_DEBUFF: {
    id: 269576,
    name: 'Master Marksman',
    icon: 'ability_hunter_mastermarksman',
  },
  MULTISHOT_MM: {
    id: 257620,
    name: 'Multi-Shot',
    icon: 'ability_upgrademoonglaive',
  },
  PRECISE_SHOTS_BUFF: {
    id: 260242,
    name: 'Precise Shots',
    icon: 'ability_hunter_snipertraining',
  },
  QUICK_DRAW_BUFF: {
    id: 1279347,
    name: 'Quick Draw',
    icon: 'ability_rogue_pistolshot',
  },
  RAPID_FIRE_DAMAGE: {
    id: 257045,
    name: 'Rapid Fire',
    icon: 'ability_hunter_efficiency',
  },
  RAPID_FIRE_FOCUS: {
    id: 263585,
    name: 'Rapid Fire',
    icon: 'ability_hunter_efficiency',
  },
  SPOTTERS_MARK_DEBUFF: {
    id: 466872,
    name: "Spotter's Mark",
    icon: 'inv_111_hunter_ability_eaglemark',
  },
  STEADY_SHOT_FOCUS: {
    id: 77443,
    name: 'Steady Shot',
    icon: 'ability_hunter_steadyshot',
  },
  TRICK_SHOTS_BUFF: {
    id: 257622,
    name: 'Trick Shots',
    icon: 'inv_trickshot',
  },
  VOLLEY_BUFF: {
    id: 260243,
    name: 'Volley',
    icon: 'ability_hunter_rapidkilling',
  },
  VOLLEY_DAMAGE: {
    id: 260247,
    name: 'Volley',
    icon: 'buff_epichunter',
  },
  //endregion

  //region Survival
  WALLOP_BUFF: {
    id: 1252741,
    name: 'Furious Assault',
    icon: 'spell_druid_feralchargecat',
  },
  ASPECT_OF_THE_EAGLE: {
    id: 186289,
    name: 'Aspect of the Eagle',
    icon: 'spell_hunter_aspectoftheironhawk',
  },
  HARPOON: {
    id: 190925,
    name: 'Harpoon',
    icon: 'ability_hunter_harpoon',
  },
  TERMS_OF_ENGAGEMENT_BUFF: {
    id: 265898,
    name: 'Terms of Engagement',
    icon: 'ability_hunter_harpoon',
  },
  KILL_COMMAND_SURVIVAL_DAMAGE: {
    id: 259277,
    name: 'Kill Command',
    icon: 'ability_hunter_killcommand',
  },
  FLANKERS_ADVANTAGE: {
    id: 259285,
    name: "Flanker's Advantage",
    icon: 'ability_hunter_resistanceisfutile',
  },
  RAPTOR_STRIKE_AOTE: {
    id: 265189,
    name: 'Raptor Strike',
    icon: 'ability_hunter_raptorstrike',
  },
  MONGOOSE_FURY: {
    id: 259388,
    name: 'Mongoose Fury',
    icon: 'ability_hunter_mongoosebite',
  },
  HARPOON_DAMAGE: {
    //doesn't actually do damage, but it's categorized as that
    id: 190927,
    name: 'Harpoon',
    icon: 'ability_hunter_harpoon',
  },
  WING_CLIP: {
    id: 195645,
    name: 'Wing Clip',
    icon: 'ability_rogue_trip',
  },
  TIP_OF_THE_SPEAR_CAST: {
    id: 260286,
    name: 'Tip of the Spear',
    icon: 'ability_bossmannoroth_glaivethrust',
  },
  WILDFIRE_BOMB_DOT: {
    id: 269747,
    name: 'Wildfire Bomb',
    icon: 'inv_wildfirebomb',
  },
  WILDFIRE_BOMB_IMPACT: {
    id: 265157,
    name: 'Wildfire Bomb',
    icon: 'inv_wildfirebomb',
  },
  BLOODSEEKER_BUFF: {
    id: 260249,
    name: 'Predator',
    icon: 'ability_druid_primaltenacity',
  },
  BOOMSTICK_DAMAGE: {
    id: 1261215,
    name: 'Boomstick',
    icon: 'inv_musket_04',
  },
  RAPTOR_SWIPE_DAMAGE: {
    id: 1262293,
    name: 'Raptor Swipe',
    icon: 'inv12_apextalent_hunter_raptorswipe',
  },
  RAPTOR_SWIPE_BUFF: {
    id: 1273155,
    name: 'Raptor Swipe',
    icon: 'inv12_apextalent_hunter_raptorswipe',
  },
  RAPTOR_SWIPE_BUFF_2: {
    id: 1275630,
    name: 'Raptor Swipe',
    icon: 'inv12_apextalent_hunter_raptorswipe',
  },
  RAPTOR_SWIPE_AOTE: {
    id: 1262343,
    name: 'Raptor Swipe',
    icon: 'inv12_apextalent_hunter_raptorswipe',
  },
  STRIKE_AS_ONE: {
    id: 1251779,
    name: 'Strike as One',
    icon: 'inv_coordinatedassault',
  },
  TAKEDOWN_PET_DAMAGE: {
    id: 1253862,
    name: 'Takedown',
    icon: 'inv12_ability_hunter_takedown',
  },
  TAKEDOWN_PLAYER: {
    id: 1253859,
    name: 'Takedown',
    icon: 'inv12_ability_hunter_takedown',
  },
  HATCHET_TOSS: {
    id: 193265,
    name: 'Hatchet Toss',
    icon: 'ability_hunter_hatchettoss',
  },
  //endregion

  //region Dark Ranger Hero Talents
  BLACK_ARROW_DAMAGE: {
    id: 466930,
    name: 'Black Arrow',
    icon: 'inv_ability_darkrangerhunter_blackarrow',
  },
  BLACK_ARROW_DAMAGE_2: {
    id: 468037,
    name: 'Black Arrow',
    icon: 'inv_ability_darkrangerhunter_blackarrow',
  },
  BLACK_ARROW_DAMAGE_3: {
    id: 468572,
    name: 'Black Arrow',
    icon: 'inv_ability_darkrangerhunter_blackarrow',
  },
  BLEAK_ARROWS_DAMAGE: {
    id: 467718,
    name: 'Bleak Arrows',
    icon: 'inv_quiver_1h_mawraid_d_01.jpg',
  },
  BLEAK_POWDER_DAMAGE: {
    id: 467914,
    name: 'Bleak Powder',
    icon: 'inv_misc_powder_tin',
  },
  DARK_MINION_BLIGHTED_ARROW: {
    id: 1264364,
    name: 'Blighted Arrow',
    icon: 'inv_crossbow_2h_maw_c_01',
  },
  DARK_MINION_CAST: {
    id: 1264345,
    name: 'Dark Minion',
    icon: 'spell_shadow_animatedead',
  },
  DARK_MINION_SHOOT: {
    id: 1264357,
    name: 'Shoot',
    icon: 'ability_marksmanship',
  },
  WAILING_ARROW_BUFF: {
    id: 459808,
    name: 'Wailing Arrow',
    icon: 'ability_hunter_murderofcrows',
  },
  WAILING_ARROW_DEBUFF: {
    id: 392058,
    name: 'Wailing Arrow',
    icon: 'ability_theblackarrow',
  },
  WAILING_ARROW_DAMAGE: {
    id: 392060,
    name: 'Wailing Arrow',
    icon: 'ability_theblackarrow',
  },
  WITHERING_FIRE_BUFF: {
    id: 466991,
    name: 'Withering Fire',
    icon: 'spell_shadow_shadesofdarkness',
  },
  //endregion

  //region Pack Leader Hero Talents
  URSINE_FURY_BEASTS: {
    id: 170364,
    name: 'Dire Beast',
    icon: 'Ability_hunter_bestialdiscipline',
  },
  HOWL_WYVERN_BUFF: {
    id: 462515, //Update this to the ID
    name: 'Howl of the Packleader',
    icon: 'inv_misc_elitewyvern',
  },
  STAMPEDE_READY_BUFF: {
    id: 1258338,
    name: 'Stampede',
    icon: 'ability_hunter_bestialdiscipline',
  },
  STAMPEDE_DAMAGE: {
    id: 201594,
    name: 'Stampede',
    icon: 'inv_pet_babymurlocs_blue',
  },
  STAMPEDE_ACTIVE_BUFF: {
    id: 1258345,
    name: 'Stampede',
    icon: 'ability_hunter_bestialdiscipline',
  },
  //endregion

  //region Sentinel Hero Talents
  DONT_LOOK_BACK_BUFF: {
    id: 451447,
    name: "Don't Look Back",
    icon: 'ability_racial_forceshield',
  },
  LUNAR_STORM_DAMAGE: {
    id: 1253733,
    name: 'Lunar Storm',
    icon: 'artifactability_balancedruid_moonandstars',
  },
  MOONLIGHT_CHAKRAM_BUFF: {
    id: 1264946,
    name: 'Moonlight Chakram',
    icon: 'inv_ability_hunter_deathchakram',
  },
  MOONLIGHT_CHAKRAM_CAST: {
    id: 1264949,
    name: 'Moonlight Chakram',
    icon: 'inv_ability_hunter_deathchakram',
  },
  MOONLIGHT_CHAKRAM_DAMAGE: {
    id: 1266081,
    name: 'Moonlight Chakram',
    icon: 'inv_ability_hunter_deathchakram',
  },
  SANCTIFIED_ARMAMENTS_DEBUFF: {
    id: 1253836,
    name: 'Sanctified Armaments',
    icon: 'inv_polearm_2h_arakkoa_c_01',
  },
  SENTINELS_MARK_DEBUFF: {
    id: 1253601,
    name: "Sentinel's Mark",
    icon: 'ability_ardenweald_hunter',
  },
  STARGAZER_BUFF: {
    id: 1253750,
    name: 'Stargazer',
    icon: 'icon_7fx_nightborn_astromancer_blue',
  },
  //endregion

  //region Shared Talents
  EXPLOSIVE_SHOT_DAMAGE: {
    id: 212680,
    name: 'Explosive Shot',
    icon: '6bf_explosive_shard',
  },
  KILL_COMMAND_SHARED_DAMAGE: {
    id: 83381,
    name: 'Kill Command',
    icon: 'ability_hunter_killcommand',
  },
  REJUVENATING_WIND_BUFF: {
    id: 385540,
    name: 'Rejuvenating Winds',
    icon: 'ability_druid_galewinds',
  },
  ARCANE_SHOT: {
    id: 185358,
    name: 'Arcane Shot',
    icon: 'ability_impalingbolt',
  },
  STEADY_SHOT: {
    id: 56641,
    name: 'Steady Shot',
    icon: 'ability_hunter_steadyshot',
  },
  KILL_SHOT_MM_BM: {
    id: 53351,
    name: 'Kill Shot',
    icon: 'ability_hunter_assassinate2',
  },
  KILL_SHOT_SV: {
    id: 320976,
    name: 'Kill Shot',
    icon: 'ability_hunter_assassinate2',
  },
  HUNTERS_MARK: {
    id: 257284,
    name: "Hunter's Mark",
    icon: 'ability_hunter_markedfordeath',
  },
  POSTHASTE_BUFF: {
    id: 118922,
    name: 'Posthaste',
    icon: 'ability_hunter_posthaste',
  },
  A_MURDER_OF_CROWS_DEBUFF: {
    id: 131900,
    name: 'A Murder of Crows',
    icon: 'ability_hunter_murderofcrows',
  },
  BINDING_SHOT_ROOT: {
    id: 117526,
    name: 'Binding Shot Stun',
    icon: 'spell_shaman_bindelemental',
  },
  BINDING_SHOT_TETHER: {
    id: 117405,
    name: 'Binding Shot Tether',
    icon: 'spell_shaman_bindelemental',
  },
  ASPECT_OF_THE_CHEETAH: {
    id: 186257,
    name: 'Aspect of the Cheetah',
    icon: 'ability_mount_jungletiger',
  },
  ASPECT_OF_THE_TURTLE: {
    id: 186265,
    name: 'Aspect of the Turtle',
    icon: 'ability_hunter_pet_turtle',
  },
  CONCUSSIVE_SHOT: {
    id: 5116,
    name: 'Concussive Shot',
    icon: 'spell_frost_stun',
  },
  DISENGAGE: {
    id: 781,
    name: 'Disengage',
    icon: 'ability_rogue_feint',
  },
  EXHILARATION: {
    id: 109304,
    name: 'Exhilaration',
    icon: 'ability_hunter_onewithnature',
  },
  FLARE: {
    id: 1543,
    name: 'Flare',
    icon: 'spell_fire_flare',
  },
  FREEZING_TRAP: {
    id: 187650,
    name: 'Freezing Trap',
    icon: 'spell_frost_chainsofice',
  },
  MISDIRECTION_BUFF: {
    id: 35079,
    name: 'Misdrection',
    icon: 'ability_hunter_misdirection',
  },
  TAR_TRAP: {
    id: 187698,
    name: 'Tar Trap',
    icon: 'spell_yorsahj_bloodboil_black',
  },
  TAR_TRAP_DEBUFF: {
    id: 135299,
    name: 'Tar Trap',
    icon: 'spell_yorsahj_bloodboil_black',
  },
  COUNTER_SHOT: {
    id: 147362,
    name: 'Counter Shot',
    icon: 'inv_ammo_arrow_03',
  },
  AUTO_SHOT: {
    id: 75,
    name: 'Auto Shot',
    icon: 'ability_whirlwind',
  },
  INTIMIDATION: {
    id: 19577,
    name: 'Intimidation',
    icon: 'ability_devour',
  },
  INTIMIDATION_MM: {
    id: 474421,
    name: 'Intimidation',
    icon: 'artifactability_survivalhunter_eaglesbite',
  },
  CHIMAERA_SHOT_FOCUS: {
    id: 204304,
    name: 'Chimaera Shot',
    icon: 'ability_hunter_chimerashot2',
  },
  TRANQUILIZING_SHOT: {
    id: 19801,
    name: 'Tranquilizing Shot',
    icon: 'spell_nature_drowsy',
  },
  TRAILBLAZER_BUFF: {
    id: 231390,
    name: 'Trailblazer',
    icon: 'ability_hunter_aspectmastery',
  },
  //endregion

  //region Pets
  DISMISS_PET: {
    id: 2641,
    name: 'Dismiss Pet',
    icon: 'spell_nature_spiritwolf',
  },
  PLAY_DEAD: {
    id: 209997,
    name: 'Play Dead',
    icon: 'inv_misc_pelt_bear_03',
  },
  WAKE_UP: {
    id: 210000,
    name: 'Wake Up',
    icon: 'warrior_disruptingshout',
  },
  FETCH: {
    id: 125050,
    name: 'Fetch',
    icon: 'inv_misc_bone_01',
  },
  REVIVE_PET: {
    id: 982,
    name: 'Revive Pet',
    icon: 'ability_hunter_beastsoothe',
  },
  MEND_PET: {
    id: 136,
    name: 'Mend Pet',
    icon: 'ability_hunter_mendpet',
  },
  FEIGN_DEATH: {
    id: 5384,
    name: 'Feign Death',
    icon: 'ability_rogue_feigndeath',
  },
  CALL_PET_1: {
    id: 883,
    name: 'Call Pet 1',
    icon: 'ability_hunter_beastcall',
  },
  CALL_PET_2: {
    id: 83242,
    name: 'Call Pet 2',
    icon: 'ability_hunter_beastcall',
  },
  CALL_PET_3: {
    id: 83243,
    name: 'Call Pet 3',
    icon: 'ability_hunter_beastcall',
  },
  CALL_PET_4: {
    id: 83244,
    name: 'Call Pet 4',
    icon: 'ability_hunter_beastcall',
  },
  CALL_PET_5: {
    id: 83245,
    name: 'Call Pet 5',
    icon: 'ability_hunter_beastcall',
  },
  PRIMAL_RAGE_1: {
    id: 264667,
    name: 'Primal Rage',
    icon: 'spell_shadow_unholyfrenzy',
  },
  PRIMAL_RAGE_2: {
    id: 272678,
    name: 'Primal Rage',
    icon: 'spell_shadow_unholyfrenzy',
  },
  HARRIERS_CRY: {
    id: 466904,
    name: "Harrier's Cry",
    icon: 'inv_111_hunter_ability_harrierscall',
  },
  MASTERS_CALL: {
    id: 272682,
    name: "Master's Call",
    icon: 'ability_hunter_masterscall',
  },
  FORTITUDE_OF_THE_BEAR: {
    id: 392956,
    name: 'Fortitude of the Bear',
    icon: 'spell_druid_bearhug',
  },
  SURVIVAL_OF_THE_FITTEST: {
    id: 264735,
    name: 'Survival of the Fittest',
    icon: 'spell_nature_spiritarmor',
  },
  CLAW_BASIC_ATTACK: {
    id: 16827,
    name: 'Claw',
    icon: 'ability_druid_rake',
  },
  SMACK_BASIC_ATTACK: {
    id: 49966,
    name: 'Smack',
    icon: 'ability_druid_bash',
  },
  BITE_BASIC_ATTACK: {
    id: 17253,
    name: 'Bite',
    icon: 'ability_druid_ferociousbite',
  },
  //endregion

  //region Miscellaneous
  EAGLE_EYE: {
    id: 6197,
    name: 'Eagle Eye',
    icon: 'ability_hunter_eagleeye',
  },
  EYES_OF_THE_BEAST: {
    id: 321297,
    name: 'Eyes of the Beast',
    icon: 'ability_eyeoftheowl',
  },
  SCARE_BEAST: {
    id: 1513,
    name: 'Scare Beast',
    icon: 'ability_druid_cower',
  },
  //endregion

  HOWL_OF_THE_PACKLEADER_BUFF: {
    id: 471877,
    name: 'Howl of the Pack Leader',
    icon: 'inv_ability_packleaderhunter_vicioushunt',
  },
  HOWL_OF_THE_PACKLEADER_WYVERN: {
    id: 471878,
    name: 'Howl of the Pack Leader - Wyvern',
    icon: 'inv_misc_elitewyvern',
  },
  HOWL_OF_THE_PACKLEADER_BEAR: {
    id: 472325,
    name: 'Howl of the Pack Leader - Bear',
    icon: 'ability_hunter_pet_bear',
  },
  HOWL_OF_THE_PACKLEADER_BEAR_SUMMON: {
    id: 471990,
    name: 'Bear Summon',
    icon: 'ability_hunter_pet_bear',
  },
  HOWL_OF_THE_PACKLEADER_BOAR: {
    id: 472324,
    name: 'Howl of the Pack Leader - Boar',
    icon: 'ability_hunter_pet_boar',
  },
  WYVERNS_CRY: {
    id: 471881,
    name: "Wyvern's Cry",
    icon: 'inv_misc_elitewyvern',
  },
  HOGSTRIDER_BUFF: {
    id: 472640,
    name: 'Hogstrider',
    icon: 'inv_misc_boarshead',
  },
  PL_HOGSTRIDER_DAMAGE_1: {
    id: 471938,
    name: 'Boar Charge',
    icon: 'ability_hunter_pet_boar',
  },
  PL_HOGSTRIDER_DAMAGE_2: {
    id: 471936,
    name: 'Boar Charge',
    icon: 'ability_hunter_pet_boar',
  },
  BEAR_REND_FLESH: {
    id: 471999,
    name: 'Rend Flesh',
    icon: 'spell_druid_bloodythrash',
  },
  LEAD_FROM_THE_FRONT: {
    id: 472743,
    name: 'Lead From the Front',
    icon: 'buff_epichunter',
  },

  //region Tier Sets
  //T29 2P
  T29_2P_BONUS_BEAST_MASTERY: {
    id: 393646,
    name: 'T29 2P',
    icon: 'ability_hunter_killcommand',
  },
  T29_2P_BONUS_MARKSMANSHIP: {
    id: 393648,
    name: 'T29 2P',
    icon: 'ability_hunter_barbedshot',
  },
  //T29 4P
  T29_4P_BONUS_BEAST_MASTERY: {
    id: 393647,
    name: 'T29 4P',
    icon: 'ability_hunter_focusfire',
  },
  T29_4P_BONUS_MARKSMANSHIP: {
    id: 393649,
    name: 'T29 4P',
    icon: 'ability_impalingbolt',
  },
  LETHAL_COMMAND: {
    id: 394298,
    name: 'Lethal Command',
    icon: 'ability_hunter_focusfire',
  },
  HIT_THE_MARK: {
    id: 394371,
    name: 'Find the Mark',
    icon: 'ability_hunter_barbedshot',
  },
  FOCUSING_AIM: {
    id: 394384,
    name: 'Focusing Aim',
    icon: 'ability_impalingbolt',
  },

  //endregion
} satisfies Record<string, Spell>;

export default spells;
